export const constant = {
	selector: {
		tableWrapper: '.js-voe-signification-table',
	},
	attribute: {
		data: 'data-data',
		changeUrl: 'data-change-url',
		fontColor: 'data-font-color',
		rowColor: 'data-row-color',
		rowContentColor: 'data-row-content-color',
		translations: 'data-translations',
	},
}
